const Methods = [
  { id: 'create', name: 'Created' },
  { id: 'update', name: 'Updated' },
  { id: 'destroy', name: 'Deleted' }
];

export default Methods;



// WEBPACK FOOTER //
// ./src/views/Components/Reports/ChangeHistory/StaticData/Methods.tsx